import fp from 'lodash/fp';
import React, { FC, ComponentProps, useCallback, useEffect } from 'react';
import { PartySuggestions, DaDataSuggestion, DaDataParty } from 'react-dadata';

import { Label, Input, cn, InputProps, usePrevious } from 'Modules/ui2';

import styles from './index.module.scss';


const token = 'f47078270dcde409c92d9fdef88e6f9ec32f6bc7';


type ParticipantOptionProps = Partial<ComponentProps<InputProps['visibleValue']>> & {
    data: DaDataSuggestion<DaDataParty>;
}

const ParticipantOption: FC<ParticipantOptionProps> = ({ data, className, onClick }) => (
    <div className={className} onClick={onClick}>
        {data.data.name?.short_with_opf && (
            <Label textSize='18' component='div' title={data.data.name.short_with_opf} ellipsis>
                {data.data.name.short_with_opf?.replace(/['"]+/g, '')}
            </Label>
        )}
        <Label component='div' textSize='18'>
            {data.data.inn}
        </Label>
    </div>
);

const ParticipantInput = React.forwardRef<HTMLInputElement, any>(({
    data,
    onChange,
    active,
    onValueChange,
    value,
    readOnly,
    disabled,
    ...props
}, ref) => {
    // TODO add custom control for dadata component
    const oldActive = usePrevious(active);
    const oldData = usePrevious(data);
    const oldOldData = usePrevious(oldData);
    useEffect(
        () => {
            if (oldActive !== undefined && oldActive && !active && !readOnly &&
                fp.get('value', oldData) === fp.get('value', data) &&
                fp.get('value', data) === fp.get('value', oldOldData))
                onChange({ target: { value: '' } });
        },
        [active, oldActive, onChange, oldData, oldOldData, data, readOnly],
    );

    const Option = useCallback(
        ({ className, ...props }) => (
            <ParticipantOption
                className={cn(className, styles.option)}
                data={data}
                {...props}
            />
        ),
        [data],
    );
    return (
        <Input
            ref={ref}
            onChange={onChange}
            visibleValue={!active && data && Option}
            needEvent
            value={value || ''}
            readOnly={readOnly}
            disabled={readOnly || disabled}
            {...props}
        />
    );
});


export const ParticipantSelect: FC<Omit<ComponentProps<typeof PartySuggestions>, 'token'>> =
    ({ inputProps: { className, ...inputProps }, value, onChange, ...props }) => (
        <PartySuggestions
            token={token}
            value={value}
            onChange={onChange}
            suggestionsClassName={styles.suggestions}
            suggestionClassName={styles.suggestion}
            customInput={ParticipantInput}
            inputProps={{
                ...inputProps,
                autoComplete: 'off',
                onValueChange: onChange,
                // @ts-ignore
                data: value,
            }}
            containerClassName={cn(className, styles.container)}
            renderOption={useCallback(
                participant => <ParticipantOption data={participant} />,
                [],
            )}
            {...props}
        />
    );
